import { Link, useLocation } from 'react-router-dom';

export function NotFoundPage() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-paper dark:bg-paper-dark p-6 flex items-center justify-center">
      <div className="text-center max-w-md">
        <p className="eyebrow mb-3">Erro 404</p>
        <h1 className="font-display text-7xl text-red italic tracking-tightest mb-4">
          Página não encontrada
        </h1>
        <p className="text-ink-2 dark:text-ink-dark-2 mb-8">
          A URL <code className="font-mono text-sm bg-paper-warm dark:bg-paper-dark-warm px-1.5 py-0.5 rounded">{location.pathname}</code> não corresponde a nenhuma tela do app.
        </p>
        <Link
          to="/"
          className="inline-block bg-red hover:bg-red-deep text-white px-6 py-2.5 rounded-pill font-medium transition-colors"
        >
          Voltar pra Home
        </Link>
      </div>
    </div>
  );
}
